"use client";
import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
      <p className="text-center font-rubik copyright-text">
        © {currentYear} AvelonPR OÜ
      </p>
  );
}